import React from 'react';

export const ProposedChangesNotice = ({
  boldText,
  description,
}: {
  boldText: string;
  description: string;
}) => (
  <>
    <span className="font-semibold">{boldText}</span> {description}
  </>
);
